export function upperFirstLetter(text: string) {
    return text ? text[0].toUpperCase() + text.slice(1) : null;
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/server/src/common/extensions/array/string.extensions.ts